import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';

// URL base de la API
// const API_URL = getApiBaseUrl();
const API_URL = getApiBaseUrl();

//// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = localStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const PostUniformes = async (datos) => {
  try {
    const response = await api.post("insertuniforme", datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(
        "Error al enviar datos al backend: " + error.response.data.message
      );
    } else {
      throw new Error(
        "Error al enviar datos al backend: " + error.message
      );
    }
  }
};

export const getUniformes = async () => {
  try {
    const response = await api.get('getuniforme'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener los postulantes:', error);
    throw error;
  }
};

export const PostStUniformes = async (datos) => {
  try {
    const response = await api.post("insertstocku", datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(
        "Error al enviar datos al backend: " + error.response.data.message
      );
    } else {
      throw new Error(
        "Error al enviar datos al backend: " + error.message
      );
    }
  }
};

export const getUniformesV = async () => {
  try {
    const response = await api.get('getuniformev'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener los postulantes:', error);
    throw error;
  }
};

export const getUniformesResumen = async () => {
  try {
    const response = await api.get('getuniformeresumen'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener el resumen de uniformes:', error);
    throw error;
  }
};

export const AsignarUniformes = async (datos) => {
  try {
    const response = await api.post("insertasignacionst", datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(
        "Error al enviar datos al backend: " + error.response.data.message
      );
    } else {
      throw new Error(
        "Error al enviar datos al backend: " + error.message
      );
    }
  }
};

export const updateStockU = async (id, data) => {
  try {
    const response = await api.put(`/updateStockU/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};

export const updateAsigU = async (id, data) => {
  try {
    const response = await api.put(`/updateAsignacion/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};

export const getUniformesStockmin = async () => {
  try {
    const response = await api.get('getUniformesBajos'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener los uniformes con stock bajo:', error);
    throw error;
  }
};

export const getUniformesAsignacion = async (params) => {
  try {
    const response = await api.get('getAsignacionesResumen', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los uniformes con stock bajo:', error);
    throw error;
  }
};

export const getUAsignacionHistory = async (params) => {
  try {
    const response = await api.get('getAsignacionesHistorial', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los uniformes con stock bajo:', error);
    throw error;
  }
};

export const updateUniforme= async (id, data) => {
  try {
    const response = await api.put(`/updateUniforme/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};